import { render } from "./InvestStatus.vue?vue&type=template&id=4cd954f8&scoped=true&ts=true"
import script from "./InvestStatus.vue?vue&type=script&lang=ts"
export * from "./InvestStatus.vue?vue&type=script&lang=ts"

import "./InvestStatus.vue?vue&type=style&index=0&id=4cd954f8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd954f8"]])

export default __exports__